import styled from 'styled-components';
import {
	neutralWhite, grayLightBg, graySlateLight,
	navySlateDeep, blue400, graySlateXLight,
	navyOverlay60, grayBorderAlpha,
} from '../../../themes/colors';
import { Icon } from '../../../icon';
import { Button } from '../../../button/Button';
import { LinkButton } from '../../../button/LinkButton';

export const ContentSliderCard = styled.div`
	border: 1px solid ${grayBorderAlpha};
	border-radius: 4px;
	background: ${neutralWhite};
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const ContentSliderViewport = styled.div`
	overflow: hidden;
	width: 100%;
`;

export const ContentSliderTrack = styled.div<{ $index: number; $count: number }>`
	display: flex;
	width: ${({ $count }) => $count * 100}%;
	transform: translateX(${({ $index, $count }) => -($index / $count) * 100}%);
	transition: transform 350ms cubic-bezier(0.4, 0, 0.2, 1);
	will-change: transform;
`;

export const ContentSliderSlide = styled.div<{ $count: number }>`
	width: ${({ $count }) => 100 / $count}%;
	flex-shrink: 0;
	padding: 16px;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
`;

export const ContentSliderWrapper = styled.div`
	position: relative;

	&:hover > button {
		opacity: 1;
	}
`;

export const ContentSliderImageArea = styled.div`
	width: 100%;
	aspect-ratio: 16 / 9;
	border-radius: 4px;
	overflow: hidden;
	background: ${grayLightBg};
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ContentSliderPlaceholderIcon = styled(Icon)`
	font-size: 32px;
	color: ${graySlateLight};
`;

export const ContentSliderContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-top: 16px;
	flex: 1;
`;

export const LinkButtonStyled = styled(LinkButton)`
	margin-top: auto;
`;

export const ContentSliderHeading = styled.p`
	font-size: 18px;
	font-weight: 600;
	font-family: "Red Hat Display", sans-serif;
	color: ${navySlateDeep};
	margin: 0;
`;

export const ContentSliderDescription = styled.p`
	font-size: 14px;
	font-family: "Red Hat Display", sans-serif;
	color: ${navyOverlay60};
	margin: 0;
	line-height: 1.5;
`;

export const ContentSliderArrow = styled(Button)<{ $dir: 'left' | 'right' }>`
	position: absolute;
	top: 30%;
	transform: translateY(-50%);
	${({ $dir }) => ($dir === 'left' ? 'left: 4px;' : 'right: 4px;')}
	z-index: 2;
	border-radius: 50%;
	box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
	opacity: 0;
	transition: opacity 180ms ease, background 150ms ease;
`;

export const ContentSliderDotNav = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	padding: 0 16px 16px;
`;

export const ContentSliderDot = styled.button<{ $active: boolean }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	border: none;
	padding: 0;
	cursor: pointer;
	background: ${({ $active }) => ($active ? blue400 : graySlateLight)};
	transition: background 150ms ease;

	&:hover {
		background: ${({ $active }) => ($active ? blue400 : graySlateXLight)};
	}
`;
